<style scoped>
  .subheader {
    background-color: white;
    padding: 12px;
    box-shadow: 0 5px 10px -10px black;
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 4.4rem;
    z-index: 1;
  }
</style>
<template>
  <div v-if="allowed" class="subheader">
    <v-row no-gutters class="mb-1">
      <v-col>
        <v-autocomplete
          dense
          flat
          outlined
          :placeholder="placeholder"
          v-model="value"
          :items="items"
          hide-details
          @change="showConfirm"
        />
        <anchor-confirm-dialog
          ref="confirmDialog"
          v-model="loginAsDialog"
          :title="confirmText"
          @cancel="value = null"
          @confirm="submit"
        />
      </v-col>
      </v-row>
  </div>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import { DEFINE_LOADING } from '@/store/modules/app/actions';
import { DEFINE_ROOT, RECOVER_ROOT } from '@/store/modules/user/actions';


export default {
  name: 'LoginAsDropdown',
  data: () => ({
    value: null,
    items: [],
    loading: false,
    disabled: false,
    loginAsDialog: false,
  }),
  computed: {
    allowed() {
      const hasRootUser = this.rootUser !== null && this.rootUser !== undefined;
      return hasRootUser || this.currUser.groups.includes('anchorapps:login_as');
    },
    confirmText() {
      if (!this.value) { return ''; }
      return `Do you really want to login as ${this.value.name}?`;
    },
    rootUser() {
      return this.$store.getters.root;
    },
    currUser() {
      return this.$store.getters.user;
    },
    placeholder() {
      if (this.rootUser) {
        return `Logged in as: ${this.currUser.username}`;
      }
      return 'Login as';
    },
  },
  methods: {
    rootHandler() {
      const root = this.rootUser ? null : { name: this.currUser.display_name, id: this.currUser._id };
      this.$store.dispatch(DEFINE_ROOT, { root });
    },
    fetch() {
      this.disabled = false;
      this.loading = true;

      const params = {
        active_only: true,
      };
      this.$requests.get('/v1/users', { params })
        .then(response => {
          const filterHandler = user => (user._id !== this.currUser._id);
          const mapHandler = user => {
            const value = { id: user._id, name: user.display_name };
            return { value, text: user.display_name };
          };
          const sortHandler = (a, b) => a.text.localeCompare(b.text);
          this.items = response.data
            .filter(filterHandler)
            .map(mapHandler)
            .sort(sortHandler);
        })
        .catch(() => { this.disabled = true; })
        .then(() => { this.loading = false; });
    },
    showConfirm() {
      this.loginAsDialog = true;
    },
    submit() {
      this.$store.dispatch(DEFINE_LOADING, { loading: true });

      const data = { target_id: this.value.id };
      if (this.rootUser) {
        data.root_id = this.rootUser.id;
      }
      this.$requests.post('/v1/login-as', data)
        .then(() => {
          this.rootHandler();
          window.location.href = '/';
        })
        .catch(err => {
          this.value = null;
          this.$store.dispatch(DEFINE_LOADING, { loading: false });
          if (err.response) {
            this.$toast.error(err.response.data.message, { timeout: 3000 });
          }
        });
    },
  },
  mounted() {
    this.$store.dispatch(RECOVER_ROOT)
      .then(() => {
        if (this.rootUser) {
          this.items = [{ text: this.rootUser.name, value: this.rootUser }];
        } else {
          this.fecth();
        }
      })
      .catch(() => this.fetch());
  },
};
</script>
